import React from 'react';
import { Redirect } from 'react-router-dom';
import Subscribe from 'src/components/Subscribe';
import LoadingIndicator from 'src/components/LoadingIndicator';
import { WithRecordsContainer } from 'src/contexts';
import { withIonLifeCycle } from '@ionic/react';

class WithRecordsComponent extends React.Component {
  state = { delaying: true, hasLeft: false };

  ionViewWillEnter = () => {
    if (this.props.useLifecycle && this.state.hasLeft) {
      this.props.container.goToPage();
    }
  };

  ionViewWillLeave = () => {
    if (this.props.useLifecycle) {
      this.setState({ hasLeft: true });
    }
  };

  componentDidMount = () => {
    this.props.container.goToPage();
    this.timeout = setTimeout(() => {
      if (this.state.delaying) {
        this.setState({ delaying: false });
      }
    }, this.props.delay);
  };

  render() {
    const { delaying } = this.state;
    const { container } = this.props;
    const { resources, redirect } = container.state;
    if (redirect) {
      return <Redirect to={redirect} />;
    }
    if (resources) {
      return this.props.render({
        ...container.state,
        goToPage: container.goToPage,
        paginate: container.paginate,
        setQuery: container.setQuery,
        search: container.search,
        sort: container.sort
      });
    } else if (!delaying) {
      return this.props.loader;
    } else {
      return null;
    }
  }
}

const WithRecords = withIonLifeCycle(WithRecordsComponent);

export default class SubscribedWithRecords extends React.Component {
  constructor(props) {
    super(props);
    const { container, render, delay, ...rest } = props;
    this.container = container ? container : new WithRecordsContainer(rest);
  }
  render() {
    const { delay, loader, render, useLifecycle } = this.props;
    return (
      <Subscribe
        to={[this.container]}
        render={(container) => {
          return (
            <WithRecords
              useLifecycle={useLifecycle}
              delay={delay || 500}
              loader={
                loader || (
                  <div className="d-flex h-100vh align-items-center">
                    <LoadingIndicator />
                  </div>
                )
              }
              render={render}
              container={container}
            />
          );
        }}
      />
    );
  }
}
